<template>
    <modal :name="modal_name" class="final-modal" transition="nice-modal-fade">
        <div class="v-modal-content">
            <div class="v-modal-header">
                <span class="v-modal-dialog-title v-modal-title">CALCULATION</span>
                <button type="button" class="closeModal" aria-label="Close" @click="hideTotalVariantCount()">
                    <span aria-hidden="true">
                        <i class="icon icon-close"></i>
                    </span>
                </button>
            </div>
            <div class="v-modal-body pt-0 pb-0">
                <div class="v-modal-layout d-form">
                    <div class="m-6 mb-13" v-if='product'>
                        <div class="border-radius bg-secondary pt-3 pb-3">
                            <h6 class="font-weight-bold text-white text-center text-uppercase">Total variant Count = Quantity Sold / Pours</h6>
                        </div>
                        <div class="d-flex mt-7">
                            <div class="quantity-details bx-shadow">
                                <span class="font-weight-bold d-block">Quantity Sold</span>
                                <span class="text-secondary d-block pt-3">{{ product.sold }}</span>
                            </div>
                            <div class="quantity-details pl-2 pr-2">
                                <span class="font-weight-bold d-block">Pours</span>
                                <span class="text-secondary pt-3 d-block">{{ product.measure }}</span>
                            </div>
                        </div>
                        <div class="final-cost d-flex pr-3 pt-2 mt-7 justify-content-around">
                            <div class="row w-100">
                                <div class="col-lg-6 text-center">
                                    <h6 class="text-uppercase ml-6" style="font-weight: 700 !important;">Total variant Count</h6>
                                </div>
                                <div class="col-lg-6 text-center">
                                    <h6 class="text-secondary ml-3" style="font-weight: 700 !important;">{{ total_variant_count || 0 }}</h6>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
           
        </div>
    </modal>
</template>
<script>
export default {
    props:['modal_name', 'product'],
    methods:{
        hideTotalVariantCount() {
            this.$modal.hide(this.modal_name);
        }    
    },
    computed: {
        total_variant_count(){
            if(this.product.sold / this.product.measure == Infinity){
                return 0
            }
            else if(this.product.sold / this.product.measure == NaN) {
                return 0
            }
            else{
                return this.product.sold / this.product.measure
            }
        }
    }
}
</script>
<style scoped>
.border-radius{
    border-radius: 12px;
}
.quantity-details{
    flex: 1 1 250px;
    font-size: 16px;
    text-align: center;
}
.bx-shadow{
    box-shadow: 3px 0 0px -2px #989898;
}
.final-cost{
    border-top: solid 1px #989898;
    border-bottom: solid 1px #989898;
}
</style>